/** @jsxImportSource @emotion/react */
import React, { memo } from 'react';
import type { PaddingProps, MarginProps, ColorProps, FontProps, TextDecorationProps, StyleGroup } from './helpers';
import { useStylesCss } from './helpers';
import type { TranslationValue } from './translation';
import { useTranslatedContent } from './translation';

export interface CoreTextProps extends PaddingProps, MarginProps, ColorProps, FontProps, TextDecorationProps {
  children?: React.ReactNode;
  path?: string;
  value?: TranslationValue;
  className?: string;
}

const TEXT_STYLES: StyleGroup[] = ['colors', 'font', 'padding', 'margin', 'textDecoration'] as const;

export const CoreText: React.FC<CoreTextProps> = memo(({ children, path, value, className, ...styleProps }) => {
  const translatedContent = useTranslatedContent(path, value);
  const stylesCss = useStylesCss(styleProps, TEXT_STYLES);

  if (!translatedContent && !children) return null;

  return (
    <span className={className} css={stylesCss}>
      {translatedContent}
      {children}
    </span>
  );
});

CoreText.displayName = 'CoreText';

export default CoreText;
